import { FIRMWARE_CHANNEL } from '../constants/channels'
import openCable from './cable'

const firmwareChannel = ({ request, response }) => {
  openCable(FIRMWARE_CHANNEL).then((cable) => {
    const subscription = cable.subscriptions.create(FIRMWARE_CHANNEL, {
      connected() {
        request(this)
      },
      received(data) {
        response(data)
      },
      disconnected: () => {
        global.firmwareChannel = undefined
      },
    })
    global.firmwareChannel = subscription
    return subscription
  })
}

export default firmwareChannel
